import React, { useContext, useEffect, useRef, useState } from 'react';
import api from '../../../api/api';
import LoadingIcon from '../../components/loading/loading-icon';
import PostSmItem from './post-sm-item';
import { Context } from '../../../context/global-data-provider';
import { throttle } from 'lodash';

const PostSmScrollBottom = ({ post, manager }) => {
  const { postListPart } = useContext(Context);

  const bottomRef = useRef();
  const [previousPosts, setPreviousPosts] = useState({ list: [] });
  const [previousHasMore, setPreviousHasMore] = useState(post.previousHasMore > 0);

  const pageRef = useRef(0);
  const isLoadingRef = useRef(false);
  const hasMoreRef = useRef(post.previousHasMore > 0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const abortController = new AbortController();

    // تابع دریافت پست‌های قبلی
    const fetchPreviousPosts = async () => {
      try {
        if (!bottomRef.current || isLoadingRef.current || !hasMoreRef.current) {
          return;
        }

        isLoadingRef.current = true;

        const response = await api.getPreviousPosts(post.category.id, postListPart, post.place, pageRef.current, {
          signal: abortController.signal,
        });

        if (response?.posts?.length) {
          setPreviousPosts((prevState) => ({
            ...prevState,
            list: [...prevState.list, ...response.posts],
          }));

          setPreviousHasMore(response.previousHasMore);
          hasMoreRef.current = response.previousHasMore;
          pageRef.current += 1;

          if (manager.bottomLoadStatus !== 'loaded') {
            manager.setBottomLoadStatus('loaded');
          }
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error('Error fetching previous posts:', error);
        }
      } finally {
        isLoadingRef.current = false;
      }
    };

    // بررسی وضعیت اسکرول با استفاده از throttle
    const handleScroll = throttle(() => {
      if (!bottomRef.current) {
        return;
      }

      const scrollPosition = window.scrollY + window.innerHeight;
      const bottomPosition = bottomRef.current.offsetTop;

      if (scrollPosition >= bottomPosition && !isLoadingRef.current) {
        fetchPreviousPosts();
      }
    }, 150);

    // اجرای اولیه
    fetchPreviousPosts();

    // اضافه کردن event listener
    window.addEventListener('scroll', handleScroll);

    // cleanup
    return () => {
      abortController.abort();
      window.removeEventListener('scroll', handleScroll);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <React.Fragment>
      <div className="w-100" id="bottom">
        {previousPosts.list.map((postData, i) => {
          return <PostSmItem data={postData} key={postData.id} />;
        })}
      </div>
      {previousHasMore && (
        <div className="w-100" ref={bottomRef}>
          <LoadingIcon className={'post-loading m-0'} width={32} height={32} fill={'#555555'} key={0} />
        </div>
      )}
    </React.Fragment>
  );
};

export default PostSmScrollBottom;
